import { createResource, createRoot, createSignal } from 'solid-js';
import { getAvailableLocales } from '@/shared/api/locale.api';

// createResource internally creates a memo + computed; calling it at module
// scope (outside render/createRoot) triggers "computations created outside
// createRoot" warnings. Wrapping in createRoot gives SolidJS a disposal
// context for these internal computations for the lifetime of the app.
const [shouldLoad, setShouldLoad] = createSignal(false);

const [availableLocalesResource, { refetch }] = createRoot(() =>
  createResource(shouldLoad, async (enabled) => {
    if (!enabled) return [];
    return getAvailableLocales();
  })
);

export function ensureAvailableLocalesLoaded(): void {
  if (!shouldLoad()) {
    setShouldLoad(true);
  }
}

export async function refetchAvailableLocales(): Promise<void> {
  ensureAvailableLocalesLoaded();
  await refetch();
}

export { availableLocalesResource };
